/* Store for full project bundles -- aggregates from RepoStore if populated */

import Reflux from 'reflux';
import _ from 'underscore';

import ProjectActions from '../actions/ProjectActions';
import { get } from '../redux/api';
import utils from '../utils';

/* Private Store Variables */
let _projects = {};
let updateCache = {};

// Init project into schema if not existent
function _default(id) {
  if (!_projects[id]) {
    _projects[id] = {
      data: null,
      status: {
        loading: false, // consider: set default to true
        error: null, // errors propogated from API
        updating: false,
      },
    };
  }
}

/* Store Definition */
const ProjectStore = Reflux.createStore({
  listenables: ProjectActions,
  // Method that publishes state update
  onUpdate(id, data) {
    id = utils.nuc(id);
    _default(id);
    _projects[id].data = _.extend(_projects[id].data || {}, data);
    this.trigger(_projects);
  },
  onLoadStarted(id, _data) {
    id = utils.nuc(id);
    _default(id);
    _projects[id].status.loading = true;
    this.trigger(_projects);
  },
  onLoadCompleted(id, data) {
    id = utils.nuc(id);
    _default(id);
    _projects[id].status = {
      error: null,
      loading: false,
      updating: false,
    };
    ProjectActions.update(id, data);
  },
  onLoadFailed(id, err) {
    id = utils.nuc(id);
    _projects[id].status = {
      error: err,
      loading: false,
    };
    this.trigger(_projects);
  },
  onFetchLatest(id, resolved, _options) {
    id = utils.nuc(id);
    let self = this;
    _default(id);
    _projects[id].status.updating = true;
    this.trigger(_projects);
    get(
      `/api/projects/${utils.nuc(id)}/head`,
      false,
      { resolved: resolved || undefined },
    )
      .then(resp => {
        const latest_revision = resp.data;
        return latest_revision;
      })
      .then(latest_revision => {
        _projects[id].status.updating = false;
        _projects[id].data.head = latest_revision;
        _projects[id].data.updated = Date.now();
        self.trigger(_projects);
      });
  },
  onPushUpdateStarted(id, data) {
    id = utils.nuc(id);
    _default(id);
    updateCache[id] = _.clone(_projects[id].data);
    _projects[id].status.loading = true;
    this.onUpdate(id, data);
  },

  onPushUpdateCompleted(id, data) {
    id = utils.nuc(id);
    _default(id);
    _projects[id].status.error = null;
    _projects[id].status.loading = false;
    delete updateCache[id];
    ProjectActions.update(id, data);
  },

  onPushUpdateFailed(id, err) {
    id = utils.nuc(id);
    _default(id);
    _projects[id].status.loading = false;
    _projects[id].status.error = err;
    this.onUpdate(id, updateCache[id]);
  },

  /* Accessors */
  // Note: accessors perhaps should be made "internal" in order to preserve
  // subscriber data flow pattern in views
  getProject(id) {
    return _projects[id];
  },
});

export default ProjectStore;
